<template>
  <div class="settings-notifications-container">
    <b-form @submit.prevent="onSubmit">
      <b-card
        no-body
        class=""
        v-for="(notification, index) in customNotifications"
        :key="notification.id"
        :id="'notificationCardDiv' + index"
      >
        <div class="card-header mt-3">
          <div class="row">
            <div class="col-12 col-lg-7 col-md-6 pl-3">
              <h5 class="settingsTitle settingsTitleMID display-inline-block">
                Custom Notification {{ index + 1 }}
              </h5>
              <div class="togglebutton toggleButtonMID d-inline-block">
                <label>
                  <input
                    type="checkbox"
                    :id="'customNotification' + index"
                    v-model="notification.customNotification"
                    value="1"
                  />
                  <span class="toggle"></span>
                  <input
                    type="hidden"
                    :name="'customNotification' + index"
                    :value="notification.customNotification"
                  />
                </label>
              </div>
              <input
                type="hidden"
                :name="'id' + index"
                v-model="notification.id"
              />
            </div>
            <div class="col-12 col-lg-5 col-md-6">
              <div class="justify-content-right float-right">
                <span v-if="index == 0">
                  <button
                    type="button"
                    class="mt-0"
                    :class="{
                      'btn btn-bumblebee btn-mid btn-mid-primary  btn-mid-filter btn-mid-add-item':
                        client_name == 'MID',
                    }"
                    @click="clickAddNotification()"
                  >
                    Add Notification
                  </button>
                </span>
                <span v-else>
                  <img
                    class="remove-action"
                    src="@/assets/images/my-irish-date//remove-icon.png"
                    @click="removeNotification(index)"
                  />
                </span>
              </div>
            </div>
          </div>
        </div>
        <b-card-body>
          <div class="container w-100" style="max-width: 100%">
            <b-row>
              <b-col sm="6"
                ><b-form-group
                  label="Notification type"
                  label-for="notification_type"
                  :label-class="{
                    'form-label-doomyoga': client_name == 'DY',
                    'form-label-mid': client_name == 'MID',
                  }"
                >
                  <treeselect
                    class="form-control"
                    v-model="notification.notification_type"
                    :name="'notification_type' + index"
                    :id="'notification_type' + index"
                    placeholder="Select type"
                    :multiple="false"
                    :options="notification_type_options"
                    :clearable="true"
                    :searchable="true"
                    :openOnClick="true"
                    :disable-branch-nodes="true"
                    :closeOnSelect="true"
                    :open-on-focus="true"
                    :always-open="false"
                    :normalizer="normalizer"
                    :required="true"
                  >
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.customLabel }}
                    </div>
                  </treeselect>
                </b-form-group></b-col
              >
              <b-col sm="6"
                ><b-form-group
                  label="Notification name"
                  label-for="notification_name"
                  :label-class="{
                    'form-label-doomyoga': client_name == 'DY',
                    'form-label-mid': client_name == 'MID',
                  }"
                >
                  <b-form-input
                    v-bind:class="{
                      'form-control-doomyoga': client_name == 'DY',
                      'form-control-mid': client_name == 'MID',
                    }"
                    :name="'notification_name' + index"
                    :id="'notification_name' + index"
                    v-model="notification.notification_name"
                    required
                  ></b-form-input> </b-form-group
              ></b-col>
            </b-row>
            <b-row>
              <b-col sm="6"
                ><b-form-group
                  label="Notification channel"
                  label-for="notification_channel"
                  :label-class="{
                    'form-label-doomyoga': client_name == 'DY',
                    'form-label-mid': client_name == 'MID',
                  }"
                >
                  <treeselect
                    class="form-control"
                    v-model="notification.notification_channel"
                    :name="'notification_channel' + index"
                    :id="'notification_channel' + index"
                    placeholder="Select type"
                    :multiple="false"
                    :options="notification_channel_options"
                    :clearable="true"
                    :searchable="true"
                    :openOnClick="true"
                    :disable-branch-nodes="true"
                    :closeOnSelect="true"
                    :open-on-focus="true"
                    :always-open="false"
                    :normalizer="normalizer"
                    @select="onChangeChannel(index)"
                    :required="true"
                  >
                    <!-- <div slot="value-label" slot-scope="{ node }">{{node.raw.customLabel}}</div> -->
                  </treeselect>
                </b-form-group></b-col
              >
              <!-- notification channel -->
              <b-col sm="6">
                <!-- email  -->
                <b-form-group
                  v-if="notification.notification_channel == 'email'"
                  label="Email"
                  label-for="email"
                  :label-class="{
                    'form-label-doomyoga': client_name == 'DY',
                    'form-label-mid': client_name == 'MID',
                  }"
                >
                  <template #label>
                    Email
                    <span class="float-right mr-2">
                      <!-- <button type="button" @click="clickAddNotification()"> -->
                      <img
                        width="20px"
                        src="@/assets/images/my-irish-date/add-icon.png"
                        @click="addEmail(index)"
                      />
                      <!-- </button> -->
                    </span>
                  </template>
                  <div
                    v-for="(email, email_index) in notification.email"
                    :key="email_index"
                  >
                    <b-input-group
                      class="input-group-action-mid"
                      v-bind:class="{
                        'mt-2': email_index > 0,
                      }"
                    >
                      <b-form-input
                        v-bind:class="{
                          'form-control-doomyoga': client_name == 'DY',
                          'form-control-mid': client_name == 'MID',
                        }"
                        :name="'email' + index + '[]'"
                        :id="'email' + index + '_' + email_index"
                        v-model="email.value"
                        required
                      ></b-form-input>
                      <b-input-group-append v-if="email_index !== 0">
                        <img
                          src="@/assets/images/my-irish-date/remove-icon.png"
                          @click="removeEmail(index, email_index)"
                          width="20px"
                          class="mr-2 ml-1"
                        />
                      </b-input-group-append>
                    </b-input-group>
                  </div>
                </b-form-group>
                <!-- phone number  -->
                <b-form-group
                  v-if="notification.notification_channel == 'sms'"
                  label="Phone number"
                  label-for="phone_number"
                  :label-class="{
                    'form-label-doomyoga': client_name == 'DY',
                    'form-label-mid': client_name == 'MID',
                  }"
                >
                  <template #label>
                    Phone number
                    <span class="float-right mr-2 ml-1">
                      <!-- <button type="button" @click="clickAddNotification()"> -->
                      <img
                        width="20px"
                        src="@/assets/images/my-irish-date/add-icon.png"
                        @click="addPhone(index)"
                      />
                      <!-- </button> -->
                    </span>
                  </template>
                  <div
                    v-for="(phone, phone_index) in notification.phone_number"
                    :key="phone_index"
                  >
                    <b-input-group
                      class="input-group-action-mid p-0"
                      v-bind:class="{
                        'mt-2': phone_index > 0,
                      }"
                    >
                      <!-- <b-form-input
                        v-bind:class="{
                          'form-control-doomyoga': client_name == 'DY',
                          'form-control-mid': client_name == 'MID',
                        }"
                        :name="'phone' + index + '[]'"
                        :id="'phone' + index + '_' + phone_index"
                        v-model="phone.value"
                        required
                      ></b-form-input> -->
                      <vue-tel-input
                        class="w-100"
                        v-bind:class="{
                          'form-control-doomyoga': client_name == 'DY',
                          'form-control-mid': client_name == 'MID',
                          'has-remove-action': phone_index != 0,
                        }"
                        :name="'phone' + index + '[]'"
                        :id="'phone' + index + '_' + phone_index"
                        v-model="phone.value"
                        required
                      ></vue-tel-input>

                      <b-input-group-append v-if="phone_index !== 0">
                        <img
                          src="@/assets/images/my-irish-date/remove-icon.png"
                          @click="removePhone(index, phone_index)"
                          width="20px"
                        />
                      </b-input-group-append>
                    </b-input-group>
                  </div>
                </b-form-group>
                <!-- platform  -->
                <b-form-group
                  v-if="notification.notification_channel == 'platform'"
                  label="User type"
                  label-for="user_type"
                  :label-class="{
                    'form-label-doomyoga': client_name == 'DY',
                    'form-label-mid': client_name == 'MID',
                  }"
                >
                  <treeselect
                    class="form-control"
                    v-model="notification.user_type"
                    :name="'user_type' + index"
                    :id="'user_type' + index"
                    placeholder="Select user type"
                    :multiple="false"
                    :options="users_options"
                    :clearable="true"
                    :searchable="true"
                    :openOnClick="true"
                    :disable-branch-nodes="true"
                    :closeOnSelect="true"
                    :open-on-focus="true"
                    :always-open="false"
                    search-nested
                    :normalizer="normalizer"
                    :required="true"
                  >
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.customLabel }}
                    </div>
                  </treeselect></b-form-group
                >
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12"
                ><b-form-group
                  label="Notification content"
                  label-for="notification_content"
                  :label-class="{
                    'form-label-doomyoga': client_name == 'DY',
                    'form-label-mid': client_name == 'MID',
                  }"
                >
                  <b-textarea
                    v-bind:class="{
                      'form-control-doomyoga': client_name == 'DY',
                      'form-control-mid': client_name == 'MID',
                    }"
                    :name="'notification_content' + index"
                    :id="'notification_content' + index"
                    v-model="notification.notification_content"
                    rows="4"
                    required
                  ></b-textarea> </b-form-group
              ></b-col>
            </b-row>
          </div>
        </b-card-body>
      </b-card>
      <b-row>
        <b-col lg="3" offset-lg="9" md="4" offset-md="8" sm="6" offset-sm="6">
          <b-button
            type="submit"
            :variant="client_name == 'DY' ? 'doomyoga-primary' : 'mid-primary'"
            class="w-100"
            v-bind:class="{
              'btn-bumblebee btn-doomyoga btn-doom-yoga-submit':
                client_name == 'DY',
              'btn-bumblebee btn-mid btn-mid-submit': client_name == 'MID',
            }"
            v-if="!is_loading"
          >
            Save
          </b-button>
          <b-button
            type="button"
            disabled
            :variant="client_name == 'DY' ? 'doomyoga-primary' : 'mid-primary'"
            class="w-100"
            v-bind:class="{
              'btn-bumblebee btn-doomyoga btn-doom-yoga-submit':
                client_name == 'DY',
              'btn-bumblebee btn-mid btn-mid-submit': client_name == 'MID',
            }"
            v-else
          >
            <b-spinner small label="Small Spinner" variant="light"></b-spinner>
            Loading
          </b-button>
        </b-col></b-row
      >
    </b-form>
  </div>
</template>


<script>
import $, { event } from "jquery";
import axios from "axios";

export default {
  name: "SettingsNotifications",
  props: [
    "client_name",
    "notification_type_options",
    "notification_channel_options",
    "users_options",
  ],
  data() {
    return {
      is_loading: false,
      customNotifications: [],
    };
  },
  mounted() {
    this.getNotificationsList()
  },
  methods: {
    getNotificationsList() {
      console.log("in get notifications list ", this.client_name);
      axios
        .get("cms/admin/notification-setting", {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          console.log(response.data);
          console.log(response.data.data.length);
          this.customNotifications = []
          let notification = {
            id: null,
            customNotification: "1",
            notification_type: null,
            notification_name: "",
            notification_channel: null,
            phone_number: [{ value: "" }],
            email: [{ value: "" }],
            user_type: null,
            retailer: null,
            notification_content: "",
          };
          this.customNotifications =
            response.data.data.length == 0
              ? [notification]
              : response.data.data.length;
        });
    },
    normalizer(node) {
      return {
        id: node.id,
        label: node.label,
        customLabel: node.customLabel,
        children: node.children,
      };
    },
    clickAddNotification() {
      this.customNotifications.push({
        id: null,
        customNotification: "1",
        notification_type: null,
        notification_name: "",
        notification_channel: null,
        phone_number: [{ value: "" }],
        email: [{ value: "" }],
        user_type: null,
        notification_content: "",
      });
      console.log(this.customNotifications);
    },
    removeNotification(index) {
      this.customNotifications.splice(index, 1);
    },
    onChangeChannel(notification_index) {
      console.log("change channel ");
      let selected_channel =
        this.customNotifications[notification_index].notification_channel;

      // if(selected_channel === 'sms'){
      this.customNotifications[notification_index].phone_number = [
        { value: "" },
      ];
      this.customNotifications[notification_index].email = [{ value: "" }];
      this.customNotifications[notification_index].user_type = null;
      // }
    },
    addEmail(notification_index) {
      this.customNotifications[notification_index].email.push({ value: "" });
    },
    removeEmail(notification_index, item_index) {
      this.customNotifications[notification_index].email.splice(item_index, 1);
    },
    addPhone(notification_index) {
      this.customNotifications[notification_index].phone_number.push({
        value: "",
      });
      //Intlinput code
      // setTimeout(() => {
      // 	let phone_index = this.customNotifications[notification_index].phone_number.length -1;
      // 	this.addIntlPhoneInput('phone_number' + notification_index + '_' + phone_index, 'phone_number' + notification_index + '[]')
      // }, 300);
    },
    removePhone(notification_index, item_index) {
      this.customNotifications[notification_index].phone_number.splice(
        item_index,
        1
      );
    },
    onSubmit(event) {
      console.log("submit notifications ");
      console.log(this.customNotifications);

      this.$fire({
        // title: "Title",
        text: "Notifications are saved successfully",
        type: "success",
        timer: 3000,
      }).then((r) => {
        // console.log(r.value);
      });

      this.customNotifications = [
        {
          id: null,
          customNotification: "0",
          notification_type: null,
          notification_name: "",
          notification_channel: null,
          phone_number: [{ value: "" }],
          email: [{ value: "" }],
          user_type: null,
          retailer: null,
          notification_content: "",
        },
      ];
    },
  },
};
</script>
<style >
</style>


// WEBPACK FOOTER //
// src/components/settings/Notifications.vue